<template>
	<div>
		<div class="t-headline10 font-b mgb-8 pdl-24 pdr-24">{{$t('1')}}</div>
			<div class="t-body1 t-color-bodyGrayA font-r pdl-24 pdr-24" v-html="$t('38', {str: `<span class='t-color-headlineBlack font-b'>${findId.step3.fullPhoneNumber}</span>`})">
			<!-- <span class="t-color-headlineBlack font-b" > </span> -->
					<!-- 로 전송된 <span class="t-color-red font-b">코드 6자리</span> 를 입력하시면 계정을 확인하실 수 있습니다. -->
			</div>
			<form @submit.prevent="" novalidate>
			<div class="mgt-40 pdl-24 pdr-24 position-relative">
				<label
					class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46 "
					data-mdc-auto-init="MDCTextField"
						:class="submitState && certiNumberInvalidCheck ? 'mdc-text-field--invalid' : ''"
						id="certiNumberEl"
					>
					<span class="mdc-notched-outline">
						<span class="mdc-notched-outline__leading"></span>
						<span class="mdc-notched-outline__notch">
							<span class="mdc-floating-label font-r t-body6 l-spacing45" id="my-label-id"> {{$t('39')}}  </span>
						</span>
						<span class="mdc-notched-outline__trailing"></span>
					</span>
					<input class="mdc-text-field__input font-r t-body6" type="number"
						aria-labelledby="my-label-id"
						id="certiNumber"
						name="certiNumber"
						v-model="certiNumber"
						v-validate="'required|numeric|length:6'"
						ref="certiNumber">
					<i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing" tabindex="0"
						role="button">report_problem</i>
				</label>
				<div class="mdc-text-field-helper-line ">
					<div class="mdc-text-field-helper-text mdc-text-field-helper-text--persistent t-helper mdc-text-field-helper-text--validation-msg font-r"
						id="my-helper-id" aria-hidden="true">
							<span v-show="submitState && certiNumberInvalidCheck">
											{{$t('9')}}
							</span>
					</div>
				</div>
			</div>
			<div class="mgt-50 pdl-24 pdr-24">
				<button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText mgr-8" @click="findAccount" @keypress="findAccount" tabindex="0">
					<div class="mdc-button__ripple"></div>
					<span class="mdc-button__label t-body2 font-r">{{$t('40')}}</span>
				</button>
				<button class="mdc-button t-color-secondaryBtnText"  @click="cancelFindId()" @keypress="cancelFindId()" tabindex="0">
					<div class="mdc-button__ripple"></div>
					<span class="mdc-button__label t-body2 font-r">{{$t('41')}}</span>
				</button>
			</div>
			</form>
			<div class="mgt-24 pdl-24 pdr-24">
				<a tabindex="0" @click="showMessage(1)" @keypress="showMessage(1)" class="t-body3 t-color-signBlue font-r l-spacing39">{{$t('42')}}</a>
				<span class="t-color-bodyGrayA font-r t-body3"> {{$t('43')}} </span>
					<a tabindex="0" @click="showMessage(2)" @keypress="showMessage(2)" class="t-body3 t-color-signBlue font-r l-spacing39">{{$t('44')}}</a>
			</div>
	</div>
</template>

<script>
/**
 * 계정 찾기 Step4 컴포넌트 (find account Step4 component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCTextField} from '@material/textfield'
import {MDCRipple} from '@material/ripple'
import findApi from '@/api/findApi.js'
import {mapState, mapMutations} from 'vuex'
import {findIdMixin} from '../../mixins/findId.js'

export default {
	data() {
		return {
			certiNumber: '',
			certiNumberTextField: null,
			submitState: false
		}
	},

	mixins: [findIdMixin],

	computed: {
		...mapState('findId',{
			findId : state => state,
		}),

		// 인증번호 유효성 체크(validation check certiNumber)
		certiNumberInvalidCheck() {
			let returnValue = false
			if (this.submitState) {
				if (this.errors.has('certiNumber')) {
					returnValue = true
				}else {
					returnValue = false
				}
			}

			this.certiNumberTextField.valid === !returnValue ? '' : this.certiNumberTextField.valid = !returnValue
			return returnValue
		}
	},

	mounted() {
		// 토큰값이 없을 경우 Step1로 이동(If there is no token value, go to Step1)
		if (!this.findId.step3.token) {
      this.pathName ? this.$moveLogin() : this.$moveBrandSelect();
		}
		this.setMaterialUi()
		this.$refs.certiNumber.focus()
	},

	methods: {
		// Store 변이 정의(define store mutation)
		...mapMutations('findId', ['SET_STEP2','SET_STEP3','SET_LOGINID', 'SET_LOGIN_NAME']),

		setMaterialUi() {
			window.mdc.autoInit();
			const selector = '.mdc-button, .mdc-list, .mdc-list-item, .mdc-card__primary-action, .mdc-chip-set';
			this.certiNumberTextField = new MDCTextField(document.querySelector('#certiNumberEl'))
			this.certiNumberTextField.useNativeValidation = false

			const buttonRipple = [].map.call(document.querySelectorAll(selector), function(el) {
				let button = new MDCRipple.attachTo(el)
				return button
			})
		},

		// 인증번호 발송 API 호출(Authentication number sending API call)
		getReCertiNumber() {

			let params = this.findId.step2
			let responseData = null

			// set certi number
			findApi.requestFindId(params).then((response) => {
				responseData = response.data.data
				this.SET_STEP3({
					value: this.findId.step2.value,
					token: responseData.token,
					fullPhoneNumber: this.findId.step3.fullPhoneNumber
				})

				this.$router.push({
					name: 'FindIdStep4'
				})
			}).catch((err) => {
				responseData = err.response.data.meta
				this.$error({content: responseData.errMsg}).then(() => {})
			})
		},

		// 계정찾기 위한 인증번호 확인(check certiNumber)
		findAccount() {

			this.$validator.validateAll().then((resultValid) => {
				this.submitState = true
				if (resultValid) {
					let params = {
						token: this.findId.step3.token,
						value: this.certiNumber
					}

					let responseData = null

					findApi.findId(params).then((response) => {
						responseData = response.data.data
						//console.log(responseData.loginId)
						this.SET_LOGIN_NAME(responseData.name);
						this.SET_LOGINID(responseData.loginId)
						this.$router.push({
							name: 'FindIdComplete'
						})

					}).catch((err) => {
						responseData = err.response.data.meta
						// this.errorModal({title:'잘못된 코드', content: '코드를 잘못 입력하셨습니다. <br>전송된 코드 6자리를 확인 후 다시 시도해주세요.'}).then(() => {})
						// this.$snackOpen({contents:'코드를 잘못 입력하셨습니다. <br>전송된 코드 6자리를 확인 후 다시 시도해주세요.'}).then(() => {})
						this.$snackOpen({
							contents: this.$t('52') +' '+ this.$t('53'),
							btnDisplayYN: false,
							btnDisplay:this.$t('Common.00001')
						}).then(() => {})

					})
				}else {
					this.$refs.certiNumber.focus()
				}
			})
		}
	},

}
</script>
